import { Component, OnInit } from '@angular/core';
export class DatepickerComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-datepicker',
  template: `
    <mat-form-field>
      <input matInput [matDatepicker]="picker" placeholder="Choose a date">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatepickerComponent_tsickle_Closure_declarations() {
/** @type {?} */
DatepickerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatepickerComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
